import React from 'react';

import { TranslatedMessage } from 'common/components/Intl';
import Logo from '!svg-react-loader?!images-react-svg/icons/icon-juul-logo.svg';

function Nav() {
  return (
    <div className="build-your-plan__header-wrapper">
      <div className="build-your-plan__header content-wrapper">
        <h1 className="build-your-plan__header-title heading--small">
          <TranslatedMessage id="plan_builder.landing.build_your_autoship" />
        </h1>
        <a className="build-your-plan__header-home-link" href="/">
          <Logo className="build-your-plan__header-logo" />
        </a>
      </div>
    </div>
  );
}

export default Nav;
